import * as React from "react";

import primaryColour from "../../constants";

function SvgGeofenceexit(props: React.SVGProps<SVGSVGElement>) {
  const { fill = primaryColour } = props;
  return (
    <svg width={24} height={25} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15 5.81885C15.497 5.81885 15.9 6.22179 15.9 6.71885C15.9 7.2159 15.497 7.61885 15 7.61885H9.74998C9.14246 7.61885 8.64997 8.11133 8.64997 8.71885V17.0313C8.64997 17.6389 9.14246 18.1313 9.74998 18.1313H15C15.497 18.1313 15.9 18.5343 15.9 19.0313C15.9 19.5284 15.497 19.9313 15 19.9313H9.74998C8.14835 19.9313 6.84998 18.633 6.84998 17.0313V8.71885C6.84998 7.11722 8.14835 5.81885 9.74998 5.81885H15Z"
        fill={fill}
      />
      <path
        d="M18.7488 12.1626H11.9062C11.4092 12.1626 11.0062 12.5655 11.0062 13.0626C11.0062 13.5597 11.4092 13.9626 11.9062 13.9626H18.663L17.3088 15.3168C16.9573 15.6683 16.9573 16.2381 17.3088 16.5896C17.6602 16.9411 18.2301 16.9411 18.5816 16.5896L21.405 13.7662C21.6115 13.6013 21.7437 13.3474 21.7437 13.0626C21.7437 13.0495 21.7434 13.0365 21.7429 13.0235C21.7533 12.7804 21.6657 12.5339 21.4801 12.3483L18.5815 9.44987C18.2301 9.09841 17.6602 9.09842 17.3088 9.4499C16.9573 9.80138 16.9573 10.3712 17.3088 10.7227L18.7488 12.1626Z"
        fill={fill}
      />
    </svg>
  );
}

export default SvgGeofenceexit;
